import { matchNonConformities } from './tagLogic';
import { matchTemplateFieldWithValue, monthYearFromDateObject, deadlineObjectChecker, addMonthsToDateObject, currentDateObject, dateObjectToMillis } from './utils';

/**
 * Returns an array of non-conformity ids associated with a register template's maintenance tasks
 * #deadlines
 * @param {Object} registerTemplate - Register template object
 * @returns {Array<string>} - Array of non-conformity ids
 */
export const maintenanceTaskNonConformityIds = (registerTemplate) => {
    const fields = !Array.isArray(registerTemplate?.dates) ? [] : registerTemplate?.dates
    const nonConformities = fields?.map?.((field)=>field?.nonConformities?.map?.((x)=>x?._id)).flat()
    return nonConformities
}
/**
 * Returns an array of non-conformity ids associated with a register template's maintenance tasks
 * #deadlines
 * #monthlyDeadline
 * #registerTable
 * @param {Object} deadlines - Object containing deadlines for the register template
 * @param {Object} registerTemplate - Register template object
 * @param {number} customYear - Custom year for which to check deadlines
 * @param {Object} device - Device object
 * @returns {Array<string>} - Array of non-conformity ids
 */
export const maintenanceTasksList = (deadlines, registerTemplate, customYear, device) => {
       
    const nonConformitiesMaintenanceList = (deadline, customYear) => {
    
        const check = deadlineObjectChecker(
            deadline?.dateObject, 
            false, 
            deadline?.monthlyDeadline ? true : false,
            customYear
        )
/*         if(check?.status == "OVER") {
            console.log("CHECK òlkdqwòdkwòql:",{check, customYear})
        }  */
       const field = !Array.isArray(registerTemplate?.dates) ? undefined : registerTemplate?.dates?.find?.((x)=>x?._id==deadline?.fieldId)
       const nonConformities = matchNonConformities(device, field?.nonConformities, registerTemplate)
       //if(nonConformities?.length > 1)console.log("jasolaisjdopajd", {field, nonConformities, deadline, check, device})
        if(check?.status=="OVER" && customYear){

            if(deadline?.date == customYear) {
                 //console.log(`kajncvkljn ${deadline?.label}`, {deadline, check, nonConformities, field})
                return nonConformities
            }
            if(field?.dateType == "annualTest") {
                //console.log(`lqwswlkqs ANNUAL ${deadline?.label}`, {deadline, check, nonConformities, field})
                return nonConformities}
            return []
        }
        else if(check?.status=="OVER"){
            //const field = !Array.isArray(registerTemplate?.dates) ? undefined : registerTemplate?.dates?.find?.((x)=>x?._id==deadline?.fieldId)
            //const nonConformities = field?.nonConformities
            //console.log("NON CONF MAINT TROVATA:",nonConformities)
                return nonConformities
            } else {
                //console.log("MAINT NON TROVATA")
                return []
            }
       
    }
    const templateDeadlines = Object.values(deadlines, registerTemplate)
  
    
    const expiredDeadlines = templateDeadlines?.map?.((x)=>nonConformitiesMaintenanceList(x,customYear))?.flat()
    //console.log("NON CONF MAINT TROVATA:",expiredDeadlines)

    //const nonConf = templateDeadlines?.find?.((x)=>nonConformitiesMaintenanceList(x))
    //if (nonConf) return nonConformitiesMaintenanceList(nonConf)

    if(expiredDeadlines?.length>0) return  expiredDeadlines
    return []     

}

/**
 * Returns an object containing the non-conformity maintenance tasks to be
 * performed for the given device and register template, as well as the
 * deadlines for the given device.
 * Theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
 * #deadlines
 * #monthlyDeadline
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
 export const DataScadenzaCollaudoQuinquennaleCollaudoAnnuale = (device, deviceTemplate, registerTemplate, customYear) => {

        const today = currentDateObject(customYear)
        const templateDates = registerTemplate?.dates

        const deviceDeadlinesIds = {
            annoProduzioneId:templateDates?.find?.((x)=>x?.dateType == "production")?._id,
            collaudoAnnualeId:templateDates?.find?.((x)=>x?.dateType == "annualTest")?._id,
            collaudoQuinquennaleId:templateDates?.find?.((x)=>x?.dateType == "test")?._id
        }
/*         const deviceDeadlinesIds = {
            annoProduzioneId:"0fd77d32-922b-465c-ac9c-6fac4f3f12b5",
            collaudoAnnualeId:"df6c2f10-548b-43d5-a8eb-86c4aef56cbf",
            collaudoQuinquennaleId:"8da7d159-0b11-4477-882c-5e8774f8bbe8"
        } */
        

        const {annoProduzioneId, collaudoAnnualeId, collaudoQuinquennaleId } = deviceDeadlinesIds
        const isSub = device?.status == "DA SOSTITUIRE"

        // these are the dates inserted by the use in the current device inside the fields
        const dates = {
            annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
            collaudoAnnuale:matchTemplateFieldWithValue(collaudoAnnualeId, device?.dates, deviceTemplate, true),
            collaudoQuinquennale:matchTemplateFieldWithValue(collaudoQuinquennaleId, device?.dates, deviceTemplate, true)
        } 


        const annualtestMonths = 12
        const testMonths = deviceTemplate?.testYears * 12
        const expiryMonths = deviceTemplate?.expiryYears * 12

        const objProduzione =  dates?.annoProduzione?.dateObject
        const objCollaudo = dates?.collaudoQuinquennale?.dateObject
        const objCollaudoAnnuale = dates?.collaudoAnnuale?.dateObject

        const annoProduzione =  objProduzione?.year
        const collaudoQuinquennale = objCollaudo?.year
        const collaudoAnnuale =  objCollaudoAnnuale?.year

        const annualTestDueDateObj = addMonthsToDateObject(objCollaudoAnnuale, annualtestMonths)
        const testDueDateObj = addMonthsToDateObject(objCollaudo, testMonths)
        const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)

        const todayMillis = dateObjectToMillis(today)
        const annualTestDueDateObjMillis = dateObjectToMillis(annualTestDueDateObj)
        const testDueDateObjMillis = dateObjectToMillis(testDueDateObj)
        const expiryDueDateObjMillis = dateObjectToMillis(expiryDueDateObj)     

        const scadenzeCombinazioni = () => {
            if(expiryDueDateObjMillis >= todayMillis && isSub) return undefined
            if(annoProduzione) return expiryDueDateObj
                return undefined
        } 
        //console.log("dwekdhehduhd", dates) 
        const collaudoQuinquennaleCombinazioni = () => {
            if(expiryDueDateObjMillis <= todayMillis || isSub) {return undefined}
            if (!collaudoQuinquennale){ return addMonthsToDateObject(objProduzione, testMonths)}
            return testDueDateObj
        }
        const collaudoAnnualeCombinazioni = () => {

            if(!deviceTemplate?.annualTest) {return undefined}
            if(expiryDueDateObjMillis <= todayMillis || isSub) {return undefined}
            //if(collaudoQuinquennaleCombinazioni() <= currentYear) {return Number(annualTest) && currentYear+Number(annualTest)}
            if(!collaudoAnnuale && collaudoQuinquennale) {return addMonthsToDateObject(objCollaudo, annualtestMonths)}
            if(!collaudoAnnuale && !collaudoQuinquennale) {return addMonthsToDateObject(objProduzione, annualtestMonths)}
            
            return annualTestDueDateObj
        }
        const exists = !!scadenzeCombinazioni()?.year || !!collaudoQuinquennaleCombinazioni()?.year || !!collaudoAnnualeCombinazioni()?.year
        const deadlines = {
            expiry: {
                date: scadenzeCombinazioni()?.year,
                dateObject: scadenzeCombinazioni(),
                label:"SCADENZA ESERCIZIO", 
                fieldId: annoProduzioneId,
                order: 72       
            },
            quinquennialTest: {
                date: collaudoQuinquennaleCombinazioni()?.year,
                dateObject: collaudoQuinquennaleCombinazioni(),
                label:"PROSSIMO COLLAUDO QUINQ.LE",
                monthlyDeadline: true,
                fieldId: collaudoQuinquennaleId,
                order: 71 
            },
            yearlyTest: {
                date: collaudoAnnualeCombinazioni()?.year,
                dateObject: collaudoAnnualeCombinazioni(),
                label: "PROSSIMO COLLAUDO ANNUALE",
                monthlyDeadline: true,
                fieldId: collaudoAnnualeId, 
                order: 70 
    
            }
        }
    
        const result = {
            ...deadlines,
            exists,
            maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
            maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate)
    
        }
        //if(deadlines?.expiry?.date) console.log("dnjednwkjed", result)
      // if(device?._id == "333b66dc-19d8-4288-8a85-a482a81bdc8c") console.log("IN CONSOLE SCADENZE", result)
        return result
 }

/**
 * Returns an object containing the non-conformity maintenance tasks to be
 * performed for the given device and register template, as well as the
 * deadlines for the given device.
 * Theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
 export const DataScadenzaCollaudoRevisione = (device, deviceTemplate, registerTemplate, customYear) => {
    // theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
        // #deadlines
 
    const isSub = device?.status == "DA SOSTITUIRE"
    const today = currentDateObject(customYear)
    const templateDates = registerTemplate?.dates
    
    const deviceDeadlinesIds = {
        annoProduzioneId: templateDates?.find?.((x)=>x?.dateType == "production")?._id,
        revisioneId: templateDates?.find?.((x)=>x?.dateType == "revision")?._id,
        collaudoId: templateDates?.find?.((x)=>x?.dateType == "test")?._id,
    }
/*     const deviceDeadlinesIds = {
        annoProduzioneId:"0fd77d32-922b-465c-ac9c-6fac4f3f12b5",
        revisioneId:"3dcc8283-acda-4cf0-8d1d-240ea0086821",
        collaudoId:"5509152e-2956-43b3-9c4d-4a327034e191"
    } */
  
    const {annoProduzioneId, revisioneId, collaudoId } = deviceDeadlinesIds
    
    // these are the dates inserted by the use in the current device inside the fields
    const dates = {
        annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
        revisione: matchTemplateFieldWithValue(revisioneId, device?.dates, deviceTemplate, true),
        collaudo: matchTemplateFieldWithValue(collaudoId, device?.dates, deviceTemplate, true)
    } 
  
    //const {expiryYears, testYears, revisionYears } = deviceTemplate || {}
    // NEW DATA



    const testMonths = deviceTemplate?.testYears * 12
    const expiryMonths = deviceTemplate?.expiryYears * 12

    const objProduzione =  dates?.annoProduzione?.dateObject
    const objCollaudo = dates?.collaudo?.dateObject
    const objRevisione = dates?.revisione?.dateObject

    const annoProduzione =  objProduzione?.year
    const annoCollaudo = objCollaudo?.year
    const annoRevisione =  objRevisione?.year

    const revisionMonths = () => {
        if(Number(annoProduzione) < 2024) return deviceTemplate?.oldRevisionYears * 12
        if(Number(annoProduzione) == 2024 && Number(objProduzione?.month) < 8) deviceTemplate?.oldRevisionYears * 12
        //if(Number(annoProduzione) < 2024 && !objProduzione?.month) return deviceTemplate?.oldRevisionYears * 12
        return deviceTemplate?.revisionYears * 12 }

    const revisionDueDateObj = addMonthsToDateObject(objRevisione, revisionMonths())
    const testDueDateObj = addMonthsToDateObject(objCollaudo, testMonths)
    const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)

    const todayMillis = dateObjectToMillis(today)
    const revisionDueDateObjMillis = dateObjectToMillis(revisionDueDateObj)
    const testDueDateObjMillis = dateObjectToMillis(testDueDateObj)
    const expiryDueDateObjMillis = dateObjectToMillis(expiryDueDateObj)

    //console.log("ehdiucxnewiucx", annoProduzione, collaudo, revisione)


    const scadenzeCombinazioni = () => {
       // if(expiryDueDateObjMillis >= todayMillis && isSub) return undefined
        if(annoProduzione) return (expiryDueDateObj)
            return undefined
    }
    const collaudoCombinazioni = () => {
        if(expiryDueDateObjMillis <= todayMillis ) {return undefined} //taken away || isSub
        if (!annoCollaudo){ return addMonthsToDateObject(objProduzione, testMonths)}
        return testDueDateObj
    }
    const revisioneCombinazioni = () => {
        if(expiryDueDateObjMillis <= todayMillis) {return undefined} //taken away || isSub
        //if(collaudoCombinazioni() <= currentYear) {return Number(revisionYears) && Number(revisionYears) + currentYear}
        if(!annoRevisione && annoCollaudo) {return addMonthsToDateObject(objCollaudo, revisionMonths())}
        if(!annoRevisione && !annoCollaudo) {return addMonthsToDateObject(objProduzione, revisionMonths()) }

        return revisionDueDateObj
    }
    const exists = !!scadenzeCombinazioni()?.year || !! collaudoCombinazioni()?.year || !!revisioneCombinazioni()?.year
    const deadlines = {
        expiry: {
            date: scadenzeCombinazioni()?.year,
            dateObject: scadenzeCombinazioni(),
            label:"SCADENZA ESERCIZIO", 
            fieldId: annoProduzioneId,
            order: 72       
        },
        collaudo: {
            date: collaudoCombinazioni()?.year,
            dateObject: collaudoCombinazioni(),
            label:"PROSSIMO COLLAUDO",
            fieldId: collaudoId,
            order: 71 
        },
        revisione: {
            date: revisioneCombinazioni()?.year,
            dateObject: revisioneCombinazioni(),
            label: "PROSSIMA REVISIONE",
            fieldId: revisioneId, 
            order: 70

        }
    }

    const result = {
        ...deadlines,
        exists,
        maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
        maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate)

    }
    //if(customYear && exists && result?.collaudo?.date == customYear) console.log("customYear in DataScadenzaCollaudoRevisione wèepdoèwepldo", {customYear, today, result})
    //if(!customYear && exists) console.log("nocustomYear in DataScadenzaCollaudoRevisione owjqojwd", {customYear, today, result})

    return result
}

/**
 * Returns an object containing the deadlines and maintenance tasks for the given device and device template.
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
export const DataScadenza = (device, deviceTemplate, registerTemplate, customYear) => {
    // #deadlines
    // theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed

    const today = currentDateObject(customYear)
    const templateDates = registerTemplate?.dates

    const deviceDeadlinesIds = {
        annoProduzioneId: templateDates?.find?.((x)=>x?.dateType == "production")?._id,
    }
/*     const deviceDeadlinesIds = {
        annoProduzioneId:"b049d4bb-67a6-49de-bfb9-5c5df0aedc32",
    } */
    
    const isSub = device?.status == "DA SOSTITUIRE"
  
    const {annoProduzioneId} = deviceDeadlinesIds
    
    // these are the dates inserted by the use in the current device inside the fields

    const dates = {
        annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
    } 
  
    const {annoProduzione} = dates
   
    const expiryMonths = deviceTemplate?.expiryYears * 12
    const objProduzione =  dates?.annoProduzione?.dateObject
    const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)   

    const scadenzeCombinazioni = () => {
        //if(isSub) return undefined
        if(!expiryMonths) return undefined
        if(annoProduzione) return expiryDueDateObj
            return undefined
    }
    //if(annoProduzione && scadenzeCombinazioni()?.expired) console.log("djewdewiudjeiudj", scadenzeCombinazioni())
    const exists = !!scadenzeCombinazioni()?.year
    const deadlines = {
        expiry: {
            date: scadenzeCombinazioni()?.year,
            dateObject: scadenzeCombinazioni(),
            label: "SCADENZA ESERCIZIO", 
            fieldId: annoProduzioneId,
            order: 70     
        },
    }

    const result = {
        ...deadlines,
        exists,
        maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
        maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate)

    }
    return result
}

/**
 * Returns an object containing the deadlines and maintenance tasks for the given device and device template.
 * This function is used for tagliando devices.
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
export const DataScadenzaTagliando = (device, deviceTemplate, registerTemplate, customYear) => {
    // #deadlines
    // theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed

    const today = currentDateObject(customYear)
    const templateDates = registerTemplate?.dates

    const deviceDeadlinesIds = {
        annoProduzioneId: templateDates?.find?.((x)=>x?.dateType == "production")?._id,
        collaudoId: templateDates?.find?.((x)=>x?.dateType == "test")?._id
        //annoProduzioneId:"b049d4bb-67a6-49de-bfb9-5c5df0aedc32",
        //collaudoId:"d98b32fd-b8b5-49d9-9210-199d0f314d97"
    }

    const {annoProduzioneId, collaudoId } = deviceDeadlinesIds
    const isSub = device?.status == "DA SOSTITUIRE"


    const dates = {
        annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
        collaudo:matchTemplateFieldWithValue(collaudoId, device?.dates, deviceTemplate, true)
    } 

    // these are the dates inserted by the use in the current device inside the fields
 
    const testMonths = Number(deviceTemplate?.testYears) * 12
    const expiryMonths = Number(deviceTemplate?.expiryYears) * 12

    const objProduzione =  dates?.annoProduzione?.dateObject
    const objCollaudo = dates?.collaudo?.dateObject

    const annoProduzione =  objProduzione?.year
    const collaudo = objCollaudo?.year
    //nan nan
    const testDueDateObj = addMonthsToDateObject(objCollaudo, testMonths)
    const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)

    const todayMillis = dateObjectToMillis(today)
    const testDueDateObjMillis = dateObjectToMillis(testDueDateObj)
    const expiryDueDateObjMillis = dateObjectToMillis(expiryDueDateObj)   


    const scadenzeCombinazioni = () => {
        if(expiryDueDateObjMillis >= todayMillis && isSub) return undefined
        if(!expiryDueDateObj?.year) return undefined
        if(annoProduzione) return expiryDueDateObj
        return undefined
    }
    
    const tagliandoCombinazioni = () => {
        if(expiryDueDateObjMillis <= todayMillis || isSub) {return undefined}
        if(!testMonths) return undefined
        if (!collaudo){ return addMonthsToDateObject(objProduzione, testMonths)}
        if(!testDueDateObj?.year) return undefined
        return testDueDateObj
    }
    const exists = !!scadenzeCombinazioni()?.year || !! tagliandoCombinazioni()?.year 
    const deadlines = {
        expiry: {
            date: scadenzeCombinazioni()?.year,
            dateObject: scadenzeCombinazioni(),
            label:"SCADENZA ESERCIZIO", 
            fieldId: annoProduzioneId,
            order: 71      
        },
        collaudo: {
            date: tagliandoCombinazioni()?.year,
            dateObject: tagliandoCombinazioni(),
            label:"PROSSIMO TAGLIANDO / COLLAUDO",
            fieldId: collaudoId,
            order: 70  
        },
    }

    const result = {
        ...deadlines,
        exists,
        maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
        maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate),
        testData: {collaudoId, deviceDates: device?.dates, deviceTemplate,collaudo: matchTemplateFieldWithValue(collaudoId, device?.dates, deviceTemplate, true)},

    }
    return result
}

/**
 * Returns an object containing the non-conformity maintenance tasks to be
 * performed for the given device and register template, as well as the
 * deadlines for the given device.
 * Theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
 * #deadlines
 * #monthlyDeadline
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
export const DataScadenzaCollaudo = (device, deviceTemplate, registerTemplate, customYear) => {
    
    const today = currentDateObject(customYear)
    const templateDates = registerTemplate?.dates

    const deviceDeadlinesIds = {
        annoProduzioneId: templateDates?.find?.((x)=>x?.dateType == "production")?._id,
        scadenzaId: templateDates?.find?.((x)=>x?.dateType == "expiry")?._id,
        collaudoId: templateDates?.find?.((x)=>x?.dateType == "test")?._id,
    }
/*     const deviceDeadlinesIds = {
        annoProduzioneId:"b049d4bb-67a6-49de-bfb9-5c5df0aedc32",
        scadenzaId: "b5d2372c-ca55-4d24-a5a6-7c839249b51f",
    } */
    
    
    const isSub = device?.status == "DA SOSTITUIRE"
    const {annoProduzioneId, collaudoId, scadenzaId } = deviceDeadlinesIds

    // these are the dates inserted by the user in the current device inside the fields
    const dates = {
        annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
        collaudo: matchTemplateFieldWithValue(collaudoId, device?.dates, deviceTemplate, true)
    } 
    
    
    const testMonths = deviceTemplate?.testYears * 12
    const expiryMonths = deviceTemplate?.expiryYears * 12

    const objProduzione =  dates?.annoProduzione?.dateObject
    const objCollaudo = dates?.collaudo?.dateObject

    const annoProduzione =  objProduzione?.year
    const collaudo = objCollaudo?.year

    const testDueDateObj = addMonthsToDateObject(objCollaudo, testMonths)
    const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)

    const todayMillis = dateObjectToMillis(today)
    const testDueDateObjMillis = dateObjectToMillis(testDueDateObj)
    const expiryDueDateObjMillis = dateObjectToMillis(expiryDueDateObj)  
    
    const {expiryYears, testYears, revisionYears } = deviceTemplate || {}
    const currentYear = new Date().getFullYear()


    const scadenzeCombinazioni = () => {
        if(!expiryMonths) return null
        if(expiryDueDateObjMillis >= todayMillis && isSub) return null
        if(annoProduzione) return expiryDueDateObj
            return null
    }
    
    const collaudoCombinazioni= () => {
        if(expiryDueDateObjMillis <= todayMillis || isSub) {return undefined}
        //if(!testYears) return undefined
        if (!collaudo){ return addMonthsToDateObject(objProduzione, testMonths)}
        return testDueDateObj
    }
    const exists = !!scadenzeCombinazioni()?.year || !! collaudoCombinazioni()?.year 
    const expiry = {
            date: scadenzeCombinazioni()?.year,
            dateObject: scadenzeCombinazioni(),
            label:"SCADENZA ESERCIZIO", 
            fieldId: annoProduzioneId,
            order: 71      
        }
    const deadlines = {
        expiry,
        collaudo: {
            date: collaudoCombinazioni()?.year,
            dateObject: collaudoCombinazioni(),
            label:"PROSSIMO COLLAUDO",
            fieldId: collaudoId,
            order: 70  
        },
    }

    const result = {
        ...deadlines,
        exists,
        maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
        maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate)

    }
    //console.log(("djsaldcjaslòdj", {dates, collaudoId, result}))
    return result
}

/**
 * Returns an object containing the deadlines and maintenance tasks for the given device and device template.
 * This function is used for manual devices.
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} deviceTemplate - The device template object
 * @param {Object} registerTemplate - The register template object
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
export const DataScadenzaManuale = (device, deviceTemplate, registerTemplate, customYear) => {

    const today = currentDateObject(customYear)
    const templateDates = registerTemplate?.dates

    const deviceDeadlinesIds = {
        annoProduzioneId: templateDates?.find?.((x)=>x?.dateType == "production")?._id,
        collaudoId: templateDates?.find?.((x)=>x?.dateType == "test")?._id,
        scadenzaId: templateDates?.find?.((x)=>x?.dateType == "expiry")?._id
    }
    
    const isSub = device?.status == "DA SOSTITUIRE"
    const {annoProduzioneId, scadenzaId, collaudoId } = deviceDeadlinesIds

    // these are the dates inserted by the use in the current device inside the fields
    const dates = {
        annoProduzione: matchTemplateFieldWithValue(annoProduzioneId, device?.dates, deviceTemplate, true),
        collaudo: matchTemplateFieldWithValue(collaudoId, device?.dates, deviceTemplate, true),
        annoScadenza: matchTemplateFieldWithValue(scadenzaId, device?.dates, deviceTemplate, true)
    } 


    //if(dates?.annoScadenza)console.log("kckejdnckewnc", dates)
    //console.log("rjf7834jfc8347hc", deviceDeadlinesIds)
 
    const testMonths = deviceTemplate?.testYears * 12
    const expiryMonths = deviceTemplate?.expiryYears * 12

    const objProduzione =  dates?.annoProduzione?.dateObject
    const objExpiry = dates?.annoScadenza?.dateObject
    const objCollaudo = dates?.collaudo?.dateObject

    const annoProduzione =  objProduzione?.year
    const annoScadenza = objExpiry?.year  
    const collaudo = objCollaudo?.year

    const testDueDateObj = addMonthsToDateObject(objCollaudo, testMonths)
    const expiryDueDateObj = addMonthsToDateObject(objProduzione, expiryMonths)

    const todayMillis = dateObjectToMillis(today)
    //const testDueDateObjMillis = dateObjectToMillis(testDueDateObj)
    const expiryDueDateObjMillis = dateObjectToMillis(expiryDueDateObj)

    const scadenzeCombinazioni = () => {
        if(expiryDueDateObjMillis >= todayMillis &&  isSub) return undefined
        if(annoProduzione && expiryMonths) return expiryDueDateObj
        if(!annoScadenza) return undefined
        return objExpiry
    }
    const collaudoCombinazioni= () => {
        if(expiryDueDateObjMillis <= todayMillis || isSub) {return undefined}
        //if(!testYears) return undefined
        if (!collaudo && objProduzione){ return addMonthsToDateObject(objProduzione, testMonths)}
        return testDueDateObj
    }
    const exists = !!scadenzeCombinazioni()?.year || !! collaudoCombinazioni()?.year 
    const deadlines = {
        expiry: {
            date: scadenzeCombinazioni()?.year,
            dateObject: scadenzeCombinazioni(),
            label:"SCADENZA ESERCIZIO", 
            fieldId: scadenzaId,
            order: 70     
        },
        collaudo: {
            date: collaudoCombinazioni()?.year,
            dateObject: collaudoCombinazioni(),
            label:"PROSSIMO COLLAUDO / TEST SCARICA",
            fieldId: collaudoId,
            order: 70  
        },
    }
   
    const result = {
        ...deadlines,
        exists,
        maintenanceTasksList: maintenanceTasksList(deadlines, registerTemplate, customYear, device),
        maintenanceTasksListIds: maintenanceTaskNonConformityIds(registerTemplate)

    }
    return result
}